"use client"
import type { ReactNode } from "react"
import { useConfig } from "./ConfigProvider"

/** Ohyai wordmark colors from brand logo: OH tertiary · Y white · AI primary */
export function BrandWordmark({
  text = "OHYAI",
  className,
}: {
  text?: string
  className?: string
}) {
  const brand = text.toUpperCase()
  const yIndex = brand.indexOf("Y")
  if (yIndex < 0) {
    return <span className={className}>{brand}</span>
  }
  return (
    <span className={className}>
      <span className="text-tertiary-base">{brand.slice(0, yIndex)}</span>
      <span className="text-white">{brand[yIndex]}</span>
      <span className="text-primary-base">{brand.slice(yIndex + 1)}</span>
    </span>
  )
}

export default function Brand() {
  const { COMPANY_BRAND } = useConfig()
  let mark: ReactNode
  if (typeof COMPANY_BRAND === "string" && COMPANY_BRAND.trim()) {
    mark = <BrandWordmark text={COMPANY_BRAND} />
  } else if (COMPANY_BRAND) {
    mark = COMPANY_BRAND as ReactNode
  } else {
    mark = <BrandWordmark />
  }
  return (
    <h1 className="text-xl font-bold leading-none tracking-tight">
      {mark}
    </h1>
  )
}
